var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 4,
    fill: "white",
    stroke: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.039 7.33333C17.4579 7.33333 17.8778 7.49227 18.1978 7.81415C18.4838 8.10186 18.6399 8.47119 18.6635 8.84798C18.6854 9.19786 18.5926 9.55314 18.3874 9.8538L12.1312 16.1858C11.8378 16.481 11.4602 16.639 11.0767 16.6634C10.7133 16.6864 10.3434 16.589 10.0322 16.3701L5.80223 12.1503C5.49081 11.8371 5.33333 11.4269 5.33333 11.0159C5.33333 10.6048 5.49081 10.1946 5.80223 9.88137C6.09565 9.58621 6.47324 9.42817 6.85676 9.40385C7.22012 9.38082 7.58991 9.47814 7.90108 9.69698L10.9705 12.7525L15.8803 7.81415C16.2003 7.49227 16.6202 7.33333 17.039 7.33333Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/checked-checkbox.c42323f64573797695770372e832ac1f.svg";
export { ForwardRef as ReactComponent };